/** Default services when none are stored in localStorage (`jatin_admin_services`). */
export const fallbackServices = [
  {
    id: 1,
    title: 'Interior Design',
    description: 'Complete home interior design solutions tailored to your vision.',
    image: 'https://picsum.photos/seed/interior1/400/300.jpg',
    features: ['Space planning', '3D visualization', 'Material selection'],
    order_field: 1,
    is_active: true,
  },
  {
    id: 2,
    title: 'Modular Kitchen',
    description: 'Modern kitchen layouts with premium finishes and smart storage.',
    image: 'https://picsum.photos/seed/kitchen1/400/300.jpg',
    features: ['Custom cabinets', 'Hardware', 'Lighting'],
    order_field: 2,
    is_active: true,
  },
  {
    id: 3,
    title: 'PVC & Wall Panels',
    description: 'Durable wall treatments and paneling for residential and commercial spaces.',
    image: 'https://picsum.photos/seed/panel1/400/300.jpg',
    features: ['Moisture resistant', 'Quick install', 'Many finishes'],
    order_field: 3,
    is_active: true,
  },
];
